import React, { useState, useEffect } from 'react'
// import Pagination from '@mui/material/Pagination';
import Loader from '../../../../../presentationals/Loader/Loader.component';
import NodataImage from '../../../../../../images/nodata.png';
import { getOEMDetailsByMakeclass } from '../../Community/CommunityActionCreator';
import { Callbacks } from 'jquery';
import Pagination from '../../Community/TablePagination'
import { paginationFuction } from '../../CommonUtils';
const itemsPerPage = 10;
export default function OEMtable({ handleTab }) {
    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState([]);
    const [data, setData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);

    useEffect(() => {
        getOEMDetailsByMakeclassFunction()
    }, [])

    const getOEMDetailsByMakeclassFunction = () => {
        setLoader(true)
        getOEMDetailsByMakeclass((callback) => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success" && callback?.status == 200 && callback?.data?.length > 0) {
                settableData(callback?.data)
                updatePageData(callback.data, 1);
            } else {
                settableData([])
                setData([])
            }
        })
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value)
        updatePageData(tableData, value);
    }

    const updatePageData = (datas, page) => {

        const indexOfLastItem = (page) * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = datas && datas?.length > 0 ? datas?.slice(indexOfFirstItem, indexOfLastItem) : [];
        setData(currentItems)
    };

    const paginationHandlerNew = (type, pageNumber) => {
        paginationFuction(type, pageNumber, tableData?.length, callBack => {
            console.log(callBack, 'callback')
            setcurrentPage(callBack)
            updatePageData(tableData, callBack)
        })
    }


    return (
        <>
            <div className="communitySection">
                <div className='container-fluid' style={{ marginTop: '20px' }}>
                    {
                        loader ?
                            <Loader />
                            : ''}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0px 0 30px 0' }}>
                        <h3>Vehicle OEM</h3>
                        <button
                            className='cred-btn'
                            onClick={e => handleTab('addEdit')}
                            style={{ padding: '14px 15px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-plus' /></button>

                    </div>
                    {
                        data && data?.length > 0 ?
                            <div className='table-responsive full-height'>
                                <div className="">
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className='table credhub-table' style={{ boxShadow: '0 1px 2px 0 rgba(60, 64, 67, 0.302), 0 1px 3px 1px rgba(60, 64, 67, 0.149)' }}>
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="text-center">OEM Id</th>
                                                    <th scope="col" className="text-center">Make</th>
                                                    <th scope="col" className="text-center">Make Class</th>
                                                    <th scope="col" className="text-center">Model</th>
                                                    <th scope="col" className="text-center">Vehicle Type</th>
                                                    <th scope="col" className="text-center">Variant</th>
                                                    <th scope="col" className="text-center">Year</th>
                                                    <th scope="col" className="text-center">Edit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((data, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.oemId || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.make || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.makeClass || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.model || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.vehicleType || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.variant || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.year ?? "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>
                                                                <button className='btn action-btn' onClick={e => handleTab('addEdit', data)}>
                                                                    <i className='fa fa-edit' />
                                                                </button>
                                                            </td>


                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div style={{ float: 'right', marginTop: '20px' }}>
                                    <Pagination
                                        count={Math.ceil(tableData?.length / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                    />
                                </div> */}
                                    <Pagination

                                        paginationHandlerNew={paginationHandlerNew}
                                        totalCount={tableData?.length}
                                        pageNumber={currentPage}
                                        noOfRows={itemsPerPage}
                                    />
                                </div>
                            </div>
                            :
                            <p style={{ marginTop: '100px' }} className="text-center">
                                <img src={NodataImage} style={{ width: '50%' }} alt="No data available" />
                            </p>
                    }

                </div>
            </div>
        </>
    )
}
